import { Button } from "@/components/ui/button.tsx";
import { GeneralSettingsEditor } from "@/pages/cms/general-settings";
import { CmsAdminShell } from "@/pages/cms/advanced/AdminShell";
import { useTranslation } from "react-i18next";

/**
 * Section « Réglages » de l'interface WordPress-like du CMS avancé
 * (`/cms/advanced/reglages`) : RÉUTILISE l'éditeur des réglages généraux de
 * l'ancien CMS (header sticky, réseaux sociaux, langues du site, lecteur vidéo,
 * mode CR mixte + bascule du CMS avancé) — une seule source de vérité.
 */
export default function CMSAdvancedReglages() {
  const { t } = useTranslation();

  const save = () => {
    const form = document.getElementById("general-settings");
    if (form instanceof HTMLFormElement) form.requestSubmit();
  };

  return (
    <CmsAdminShell
      title={t("cms.generalSettings.title")}
      formIds={["general-settings"]}
      actions={<Button onClick={save}>{t("cmsEnregistrerBouton")}</Button>}
    >
      <div className="max-w-7xl px-6 py-6">
        <GeneralSettingsEditor />
      </div>
    </CmsAdminShell>
  );
}
